<template>
  <div class="fromListNe">
    <div
      class="rightfor"
      ref="left"
      :style="{
        backgroundColor: '#e2ebf1',
        width: treeHidder == true ? '10px' : '',
        height: '100%',
      }"
    >
      <tree
        :treedata="treeData"
        @Afffor="Afffor"
        @serchBten="serchBten"
        @treesList="treesList"
        @treesUid="treesUid"
        :dataobjs="dataobjs"
        :fly-tay="flyTay"
        :tree-hidder="treeHidder"
        :style="{ width: treeHidder == true ? 0 : '' }"
        :keystree="keystree"
      />
      <div class="newimgList_Warp" @click="isShowFly">
        <img src="@/assets/img/xiaz.png" alt />
      </div>
    </div>
    <div class="leftNNert" :style="{ width: treeHidder == true ? '99%' : '85%' }">
      <div class="storch">
        <div class="btnes contHeader">
          <!-- <el-button type="success" @click="addContent" class="boxli">查询</el-button> -->
          <el-button
            type="primary"
            icon="el-icon-edit"
            @click="lookDlg()"
            :disabled="area_uuid != '' ? false : true"
            v-if="flyNameList == 0"
          >{{ dataobjs.xinzengwanggan }}</el-button>

          <div style="padding: 0 20px" v-if="optionsChiiend.length != 0">
            <span style="margin: 0 3px; display: inline-flex">{{dataobjs.qingxuanzewangquyu}}:</span>
            <el-select
              v-model="valueUiid"
              placeholder="请选择区域"
              @change="mychange"
              style="height: 20px"
            >
              <el-option :key="0" label="全部" :value="0" v-if="optionsChiiend.length > 1"></el-option>
              <el-option
                v-for="item in optionsChiiend"
                :key="item.uuid"
                :label="item.areaname"
                :value="item.uuid"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        :row-class-name="tableRowClassName"
        :max-height="heagintH"
        border
      >
        <el-table-column :label="dataobjs.wangguanmingcheng" align="center" fixed width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="dataobjs.anzhuangdizhi"
          :show-overflow-tooltip="true"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.address }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="IP地址" :show-overflow-tooltip="true" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.ip }}</span>
          </template>
        </el-table-column>-->
        <!-- <el-table-column label="端口号" :show-overflow-tooltip="true" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.port }}</span>
          </template>
        </el-table-column>-->
        <!-- <el-table-column label="串口波特率" :show-overflow-tooltip="true" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.baudrate }}</span>
          </template>
        </el-table-column>-->
        <!-- <el-table-column label="奇偶校验" :show-overflow-tooltip="true" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.parity }}</span>
          </template>
        </el-table-column>-->
        <el-table-column
          :label="dataobjs.wangguanzhuangtai"
          :show-overflow-tooltip="true"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.state == 0 ? "离线" : "在线" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="dataobjs.shujushangchuanpinlv"
          :show-overflow-tooltip="true"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.uploadtime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="dataobjs.haiba"
          :show-overflow-tooltip="true"
          align="center"
          width="120"
        >
          <template slot-scope="scope" align="center">
            <!-- <el-button type="primary" size="mini" icon="el-icon-setting" @click="setUpClick">设置</el-button> -->
            <span>{{ scope.row.altitude }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="dataobjs.shengchanriqi"
          :show-overflow-tooltip="true"
          align="center"
          width="120"
        >
          <template slot-scope="scope" align="center">
            <!-- <el-button type="primary" size="mini" icon="el-icon-setting" @click="setUpClick">设置</el-button> -->
            <span>{{ scope.row.productiondate }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="dataobjs.youxiaoqi"
          :show-overflow-tooltip="true"
          align="center"
          width="120"
        >
          <template slot-scope="scope" align="center">
            <!-- <el-button type="primary" size="mini" icon="el-icon-setting" @click="setUpClick">设置</el-button> -->
            <span>{{ scope.row.exprirydate }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="dataobjs.shifouzaixian"
          :show-overflow-tooltip="true"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <span>
              {{
              scope.row.isallonline == 0
              ? "否"
              : scope.row.isallonline == 1
              ? "是"
              : ""
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          :label="dataobjs.shifoukejiankong"
          :show-overflow-tooltip="true"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.ismonitor == 0 ? "否" : "是" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="dataobjs.shifoukekongzhi"
          :show-overflow-tooltip="true"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.iscontrol == 0 ? "否" : "是" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="dataobjs.shifoukeyidong"
          :show-overflow-tooltip="true"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.ismove == 0 ? "否" : "是" }}</span>
          </template>
        </el-table-column>

        <el-table-column
          :label="dataobjs.gongdianleixing"
          :show-overflow-tooltip="true"
          align="center"
        >
          <template slot-scope="scope">
            <span>
              {{
              scope.row.powertype == 0 ? "市电供电" : "电池供电"
              }}
            </span>
          </template>
        </el-table-column>


        <el-table-column
          :label="dataobjs.jingdu"
          :show-overflow-tooltip="true"
          align="center"
          sortable
          width="120"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.longitude }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="dataobjs.weidu" :show-overflow-tooltip="true" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.latitude }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="dataobjs.caozuo" align="center" fixed="right" width="370">
          <template slot-scope="{ row }">
            <!-- <el-button size="mini" icon="el-icon-view" round type="info" @click="detileData(row)">详情</el-button> -->
            <el-button
              size="mini"
              @click="editFrom(row)"
              round
              icon="el-icon-edit"
              type="primary"
            >{{ dataobjs.xiugai }}</el-button>
            <el-button
              v-if="flyNameList == 0"
              size="mini"
              type="danger"
              @click="deleData(row)"
              icon="el-icon-delete"
              round
            >{{ dataobjs.shanchu }}</el-button>
            <el-button
              size="mini"
              type="info"
              round
              v-if="flyNameList == 0"
              icon="el-icon-document-copy"
              @click="copyCick(row)"
            >{{ dataobjs.fuzhi }}</el-button>
            <el-button
              size="mini"
              type="info"
              round
              v-if="flyNameList == 0"
              icon="el-icon-edit"
              @click="copyCickYdong(row)"
            >{{dataobjs.yidong}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- :getTableList="PostJsonData" -->
      <page-helper :page-data="pageData" :total="total" :get-table-list="PostJsonData"></page-helper>
      <!-- 设备添加 -->
      <el-dialog
        :title="title"
        :modal-append-to-body="false"
        :visible.sync="dialogVisible"
        fullscreen
        :before-close="handleClose"
        :modal="false"
        top="5%"
        :close-on-click-modal="false"
      >
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick" :before-leave="alst">
          <el-tab-pane :label="chendFrom.jibenxinxi" name="first">
            <edit
            :bentflagJxs="bentflagJxs"
              :upperand="qyAlllist"
              :disable-dt="disableDt"
              :bentflag="bentflag"
              @cancelClick="cancle"
              :checked-citiesdata="checkedCitiesdata"
              style="heigth: 100%"
              :data-json="dataJson"
              :closefale="closefale"
              :post-data="PostJsonData"
              :areauuid="area_uuid"
              :get-data="she_xiang_tyou"
              ref="fromData"
              @mygateway_uuid="mygateway_uuid"
            />
          </el-tab-pane>
          <el-tab-pane :label="chendFrom.tongdaoxinxi" name="second">
            <gatewayParam
              :gatewayuuid="gateway_uuid"
              style="heigth: 100%"
              :flyuuid="flyUuid"
              @myPremnt="myPremnt"
              :flynames="flyNameList"
              ref="tableROM"
            />
          </el-tab-pane>

           <el-tab-pane label="继电器参数" name="kongzhiqi">
            <kong_Zhi_Qi  :gatewayuuid="gateway_uuid" />
          </el-tab-pane>
        </el-tabs>
      </el-dialog>

      <!-- 短信 -->
      <el-dialog
        title
        :visible.sync="dialogVisiblePhone"
        width="20%"
        :before-close="handleClosephone"
      >
        <editphone @cancelClick="canclePhone" />
      </el-dialog>
    </div>
    <!--复制  -->
    <el-dialog
      :title="titile_info"
      :visible.sync="dialogVisibleDetile"
      :modal="false"
      :close-on-click-modal="false"
      width="30%"
      :before-close="handClick"
    >
      <detile
        v-if="titile_info == '复制'"
        :options-chiiend="optionsChiiend"
        :closefale="closefalephone"
        ref="detidt"
        :value-uiid="arendValue"
        :dataobjs="dataobjs"
        :rule-formdeit="ruleFormdeit"
        @myListName="myListName"
      />
      <yidongwanguan
        :for-rend="treeDataYd"
        :options-chiiend="optionsChiiend"
        :uuid="forRendFlend"
        v-else
        :closefale="closefalephone"
      />
    </el-dialog>
    <!-- 封装的分页 -->
  </div>
</template>
<script>
import {
  treeinfo,
  Alist,
  areainfoDetile,
  gatewayinfo,
  dealerDelete,
  GatewayinfoTab,
  Alistprovince,
  Alistcity,
  Alistcounty,
  AlisttreesList,
  AlisttreesUid,
  lang_fend,
  dataUpdataD,
  coplyEnd,
  arealistFromg,
  treeinfoLend,
  KongZhiList
} from "@/network/index";
import { setTimeout } from "timers";
import edit from "./component/edit";
import PageHelper from "@/components/common/PageHelper";
import tree from "@/components/common/tree";
import editphone from "./component/editphone"; //短信设置
import detile from "./component/detile"; //查看详情
import nameDite from "./component/nameDite"; //设置别名
import gatewayParam from "./component/gatewayParam";
import yidongwanguan from "./component/yidongwanguan";
import { mapState } from "vuex";
import { Camers_Data } from "@/network/lineRequest";
import kong_Zhi_Qi from './component/kong_Zhi_Qi'
export default {
  components: {
    edit,
    kong_Zhi_Qi,
    PageHelper,
    tree,
    editphone,
    detile,
    nameDite,
    gatewayParam,
    yidongwanguan,
  },
  data() {
    return {
      bentflag: false,
      she_xiang_tyou: [],
      forRendFlend: "",
      treeDataYd: [],
      forRend: "",
      titile_info: "",
      valueUiid: "",
      activeName: "first",
      treeHidder: false,
      title: "网关添加",
      dataJson: {
        gatewayid: "", //网管id
        name: "", //网管名称
        port: "", //端口号
        baudrate: "", //般若氯
        parity: "", //奇偶校验
        area_uuid: "", //所属区域UUID
        type_uuid: "", //所属网关型号UUID
        state: "0", //网关状态0：离线 1：在线
        factorcountint: "", //观察要素个数（通道）
        address: "", //地址
        addressphoto: "", //安装位置照片
        longitude: "", //经度
        latitude: "", //纬度
        altitude: "", //海拔
        productiondate: null, //生产日期
        exprirydate: null, //有效期
        ismonitor: "0", //是否可监控0：否 1：是  1true
        iscontrol: "0", //是否可控制0：否 1：是
        ismove: "0", //是否可移动0：否 1：是
        uploadtime: "", //数据上传频率(分)
        powertype: "0", //供电类型0：市电供电 1：电池供电
        isallonline: "0", //是否在线 0 否 1是
      },
      dialogVisibleDetile: false,
      lang_file: sessionStorage.getItem("lang_file"),
      flyNameList: sessionStorage.getItem("roletypeValue"),
      isagree:sessionStorage.getItem("isagree"),
      textContent: "正在努力加载中...",
      tableData: [],
      dialogVisible: false,
      dialogVisiblePhone: false, //短信设置
      loading: true,
      search: "",
      pageSizes: [5, 10, 15, 20],
      tableQuery: {
        queryMap: {},
        page: 1,
        rows: 10,
        total: 10,
      },
      checkedCitiesdata: [],
      bentflagJxs:false,
      isAdd: "",
      apiFly: null,
      Delectloading: false,
      times: "",
      treeData: [],
      optionsChiiend: [],
      area_uuid: "",
      pageData: {
        pagenum: 1, //页码  pagenum  2
        pagesize: 30, //数据   pagesize几条数据
      },
      total: null,
      flyTay: false,
      keystree: [],
      disableDt: false,
      province: "", //省
      city: "", //市
      county: "", //区
      dealer_uuid: "", //经销商uuid
      customer_uuid: "", //所属客户uuid
      gateway_uuid: "",
      flyUuid: "",
      fnet: false,
      cunt: false,
      dataobjs: {},
      chendFrom: {},
      dataobjsEnd: {},
      allQy: "",
      ruleFormdeit: {
        gatewayid: "",
        uuid: "",
        area_uuid: "",
      },
      arendValue: "",
      customer_uuidNames: "",
      she_you: "", //获取摄像头id
    };
  },
  computed: {
    ...mapState(["wangData"]),
    heagintH() {
      return window.innerHeight - 180;
    },
  },
  mounted() {
    this.treeinfo();
    this.treeinfoYdong();
    // var x = '0002';
    // alert(Number(x));
    this.lang_fend();
    // console.log(this.wangData);
    this.GatewayinfoTab();
  
  },
  methods: {
    // 获取摄像头
    async Camers_Data() {
      let newData = {
        area_uuid: this.she_you,
      };
      const { code, data } = await Camers_Data(newData);
      console.log(data);
      this.she_xiang_tyou = data;
    },
    // 下拉框
    mychange() {
      if (this.valueUiid != 0) {
        this.area_uuid = this.valueUiid;
        this.dataJson.area_uuid = this.valueUiid;
        this.she_you = this.valueUiid;
        this.PostJsonData();
      } else {
        this.qyAlllist();
      }
    },
    handClick() {
      //  this.$refs.detidt.cloneHide()
      this.ruleFormdeit.area_uuid = "";
      this.dialogVisibleDetile = false;
    },

    // 展示全部区域
    async qyAlllist() {
      let pagenum = this.pageData.pagenum; //页码
      let pagesize = this.pageData.pagesize; //多少条数据
      const res = await AlisttreesUid(this.allQy, pagenum, pagesize);
      // console.log(res,"555555555");

      this.area_uuid = "";

      this.total = Number(res.data.pagelist[0].allrow);
      if (res != "") {
        this.optionsChiiend = res.data.arealist; //下拉框

        this.tableData = res.data.list;
        if (res.data.arealist.length === 1) {
          this.valueUiid = res.data.arealist[0].uuid; //如果下拉框里面就一个值就就赋值
          this.area_uuid = res.data.arealist[0].uuid;
          this.she_you = res.data.arealist[0].uuid; //获取下拉框的uuid给摄像头

          this.dataJson.area_uuid = res.data.arealist[0].uuid;
        }
        this.ruleFormdeit.area_uuid = res.data.arealist[0].uuid;
      }

      this.Delectloading = false;
      this.loading = false; //关闭加载图标
    },
    // 复制功能
    copyCick(e) {
      this.titile_info = "复制";
      this.ruleFormdeit.uuid = e.uuid;
      this.dialogVisibleDetile = true;
      this.$nextTick(() => {
        this.$refs.detidt.dialogints();
      });
    },
    // 移动网关
    async copyCickYdong(e) {
      // console.log(e.customer_uuid);
      const { code, data } = await arealistFromg(e.customer_uuid);
      this.forRendFlend = e.uuid;
      this.optionsChiiend = data;
      this.titile_info = this.dataobjs.yidong;
      this.dialogVisibleDetile = true;
    },
    // 复制去确定按钮
    async myListName(e) {
      // console.log(this.ruleFormdeit);
      let objName = e;

      const { code, data, msg } = await coplyEnd(objName);
      // console.log(msg);
      if (code) {
        this.$message.success(msg);
        this.dialogVisibleDetile = false;
        // this.ruleFormdeit = {}
        this.ruleFormdeit.area_uuid = "";
        this.$refs.detidt.cloneHide();
        this.countDateName();
        return false;
      }
      this.$message.error(msg);
    },
    myPremnt(e) {
      this.chendFrom = e;
    },
    // 翻译
    async lang_fend() {
      let page = "gateway_page";
      let objs = {
        page,
        lang_file: this.lang_file,
      };
      const { data, code } = await lang_fend(objs);
      // console.log(data);

      this.dataobjs = data;
    },
    //   async lang_fendTable() {
    //   let page = "gateway_add_page";
    //   let objs = {
    //     page,
    //     lang_file: this.lang_file,
    //   };
    //   const { data, code } = await lang_fend(objs);
    //   console.log(data);

    //   this.dataobjsEnd = data;
    // },
    alst(e) {
      // console.log(e);
      if (e == "second") {
        return this.fnet;
      }else if(e == 'kongzhiqi'){
         return this.fnet;
      }
    },
    Afffor(e) {
      //  setTimeout(() => {
      //   var element = this.$refs.left;
      //   element.scrollIntoView();
      //   element.scrollIntoView(true);
      //   for (let i = 0; i < 6; i++) {
      //     element.scrollIntoView({ block: "end" });
      //   }

      //   element.scrollIntoView({
      //     behavior: "smooth",
      //     block: "end",
      //     inline: "nearest",
      //   });
      // }, 500);
      switch (e.fieldname) {
        case "city":
          this.Alistcity(e.fieldname, e.uuid);
          let nameTilte = { name: e.uuid, title: "市" };
          this.$store.commit("wangGunData", nameTilte);
          break;
        case "province":
          this.newtL(e.fieldname, e.uuid);
          let nameTilte2 = { name: e.uuid, title: "省" };
          this.$store.commit("wangGunData", nameTilte2);
          break;
        case "county":
          this.Alistcounty(e.fieldname, e.uuid);
          let nameTilte3 = { name: e.uuid, title: "区" };
          this.$store.commit("wangGunData", nameTilte3);
          break;
      }
    },
    // 网关省
    async newtL(e, b) {
      let provincecode = b;
      this.Delectloading = true;
      let pagenum = this.pageData.pagenum; //页码
      let pagesize = this.pageData.pagesize; //多少条数据
      const res = await Alistprovince(provincecode, pagenum, pagesize);
      this.area_uuid = "";
      this.total = Number(res.data.pagelist[0].allrow);
      if (res != "") {
        this.tableData = res.data.list;
      }

      this.Delectloading = false;
      this.loading = false; //关闭加载图标
    },
    // 网关市
    async Alistcity(e, b) {
      let citycode = b;
      this.Delectloading = true;
      let pagenum = this.pageData.pagenum; //页码
      let pagesize = this.pageData.pagesize; //多少条数据
      const res = await Alistcity(citycode, pagenum, pagesize);
      //  console.log(res);
      this.area_uuid = "";
      this.total = Number(res.data.pagelist[0].allrow);
      if (res != "") {
        this.tableData = res.data.list;
      }

      this.Delectloading = false;
      this.loading = false; //关闭加载图标
    },
    // 网关区域
    async Alistcounty(e, b) {
      let countycode = b;
      this.Delectloading = true;
      let pagenum = this.pageData.pagenum; //页码
      let pagesize = this.pageData.pagesize; //多少条数据
      const res = await Alistcounty(countycode, pagenum, pagesize);
      this.area_uuid = "";

      this.total = Number(res.data.pagelist[0].allrow);
      if (res != "") {
        this.tableData = res.data.list;
      }

      this.Delectloading = false;
      this.loading = false; //关闭加载图标
    },
    //网关 经销商
    async treesList(e) {
      let dealer_uuid = e;
      this.Delectloading = true;
      let pagenum = this.pageData.pagenum; //页码
      let pagesize = this.pageData.pagesize; //多少条数据
      const res = await AlisttreesList(dealer_uuid, pagenum, pagesize);
      this.area_uuid = "";

      this.total = Number(res.data.pagelist[0].allrow);
      if (res != "") {
        this.tableData = res.data.list;
      }

      this.Delectloading = false;
      this.loading = false; //关闭加载图标
    },
    // 网关客户
    treesUid(e) {
      //北京大学
      let dataName = {
        name: e,
        title: "北京大学",
      };
      // this.$store.commit("wangGunData", dataName);
      this.allQy = e;
      this.valueUiid = 0;
      this.customer_uuidNames = e;
      this.countDateName();
    },
    async countDateName() {
      this.Delectloading = true;
      let pagenum = this.pageData.pagenum; //页码
      let pagesize = this.pageData.pagesize; //多少条数据
      const res = await AlisttreesUid(
        this.customer_uuidNames,
        pagenum,
        pagesize
      );
      this.area_uuid = "";

      this.total = Number(res.data.pagelist[0].allrow);
      if (res != "") {
        this.tableData = res.data.list;

        if (res.data.arealist != undefined) {
          this.optionsChiiend = res.data.arealist; //下拉框
          if (res.data.arealist.length === 1) {
            this.valueUiid = res.data.arealist[0].uuid; //如果下拉框里面就一个值就就赋值
            this.area_uuid = res.data.arealist[0].uuid;
            this.she_you = res.data.arealist[0].uuid; //摄像头
            // this.arendValue =  res.data.arealist[0].uuid//弹框里面的默认值
            this.dataJson.area_uuid = res.data.arealist[0].uuid;
          }
          this.ruleFormdeit.area_uuid = res.data.arealist[0].uuid;
        }
      }

      this.Delectloading = false;
      this.loading = false; //关闭加载图标
    },
    // 根据gateway_uuid判断是否显示选项卡
    mygateway_uuid(e) {
      console.log(e);
      this.gateway_uuid = e.gateway_uuid;
      this.cunt = true;
    },
    // 切换选项卡
    handleClick(e) {
      // this.activeName = 'first'
      if (this.gateway_uuid != "") {
        this.fnet = true;
        this.activeName = e.name;
        // this.activeName = 'kongzhiqi'
      } else {
        // console.log('11');
        
        this.activeName = "first";
        this.$message.error("请补充基本信息");
      }
    },
    // 树折叠
    isShowFly() {
      this.treeHidder = !this.treeHidder;
    },
    // 打开默认区域
    async GatewayinfoTab() {
      let pagenum = this.pagenum;
      let pagesize = this.pagesize;
      const { code, data } = await GatewayinfoTab(pagenum, pagesize);
      let lengthInfo = data.default.length - 1;
      console.log(data);
      if (this.flyNameList == 2) {
        this.optionsChiiend = data.arealist;
        // this.valueUiid = 0;
      }

      this.area_uuid = data.default[lengthInfo].uuid;
      // console.log(this.area_uuid);

      this.keystree.push(data.default[lengthInfo].uuid);
      // this.cunt = true;
      this.total = Number(data.pagelist[0].allrow);
      if (data != "") {
        this.tableData = data.list;
      }

      this.Delectloading = false;
      this.loading = false; //关闭加载图标
    },
    // 搜索功能
    serchBten(e) {
      this.flyTay = true;
      this.treeinfo(e);
    },
    // // 树形结构的数据
    // mytreeDataList(e, lable) {
    //   // if(e.uuid<3){
    //   //    console.log(e.lable);
    //   // }

    //   this.dataJson.area_uuid = e;
    //   this.dataJson.name = lable;
    //   this.area_uuid = e;
    //   this.cunt = false;
    //   let dataName = {
    //     name: e,
    //     title: "默认区域",
    //   };
    //   this.$store.commit("wangGunData", dataName);
    //   this.PostJsonData();

    //   this.dataJson.name = lable;
    // },
    // 树形结构
    async treeinfo(search) {
      let levelid = 2;
      const { code, data, msg } = await treeinfo(levelid, search);
      // console.log(data);

      if (code) {
        this.treeData = data;
      }
    },
    // y移动网关树
    async treeinfoYdong(search) {
      let levelid = 3;
      let areaflag = 1;
      const { code, data, msg } = await treeinfoLend(levelid, areaflag);
      console.log(data);

      if (code) {
        this.treeDataYd = data;
      }
    },
    funt() {
      this.$router.push("/list");
    },
    // 关闭子组件的详情弹框
    async detileData(e) {
      const res = await gatewayinfo(e.uuid);
      console.log(res);

      res.forEach((element) => {
        this.dataJson = element;
      });

      this.dialogVisibleDetile = true;
    },
    // 设置短信
    setUpClick() {
      this.dialogVisiblePhone = true;
    },
    // 关闭短息设置
    handleClosephone(done) {
      // console.log(11);

      done();
    },
    // 短息确定按钮
    canclePhone() {},
    //给复制
    closefalephone() {
      this.dialogVisibleDetile = false;
    },
    // handleCurrentChange(val) {
    //   console.log(val);
    //   this.tableQuery.page = val;
    //   this.PostJsonData();
    // },
    async PostJsonData(area_uuid) {
      this.Delectloading = true;
      let pagenum = this.pageData.pagenum; //页码
      let pagesize = this.pageData.pagesize; //多少条数据
      // console.log(this.dataJson.area_uuid);
      // let area_uuid =
      //   this.dataJson.area_uuid == undefined
      //     ? this.area_uuid
      //     : this.dataJson.area_uuid;
      // console.log(area_uuid);
      // console.log(this.valueUiid);

      const res = await Alist(this.valueUiid, pagenum, pagesize);
      // console.log('1111');

      this.total = Number(res.data.pagelist[0].allrow);
      if (res != "") {
        if (this.cunt) {
          this.activeName = "second"; //tab切换
          this.fnet = true;
          // console.log('111222');
        }

        this.tableData = res.data.list;
      }
      // console.log('1111');

      this.Delectloading = false;
      this.loading = false; //关闭加载图标
      // this.cunt = true;

      // let { result, data } = res;
      // if (result) {
      // this.Delectloading = false;
      // this.loading = false; //关闭加载图标

      // this.tableQuery.total = res.data.total;
      // } else {
      // this.textContent = "网络错误请稍后...";
      // this.Delectloading = false;
      // }
    },
    tableRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    //编辑按钮
    async editFrom(e) {
      console.log(e);
      
      this.she_you = e.area_uuid;
      this.title = this.dataobjs.xiugai;
      this.dataJson = { ...e };
      this.gateway_uuid = e.uuid;
      this.flyUuid = "1";
      // console.log(e.monitor_list);

      if (e.monitor_list != null) {
        //给关联摄像头复选框赋值
        this.checkedCitiesdata = e.monitor_list.split(",");
      } else {
        this.checkedCitiesdata = [];
      }

      // console.log(e);
      const { code, data } = await dataUpdataD(e.uuid);
      // console.log(data,"-------");
      let objsKongZ = {
        gateway_uuid:data.gateway_uuid,
        uuid:e.uuid//网关uuid不着调
      }
      // this.KongZhiBna(objsKongZ)//控制板设置
      //  false 是可以修改id true不能修改id
      this.disableDt = data.flag == 1 ? true : false;
      if(this.flyNameList == 0 && this.isagree == 0){//如果是平台子賬號
         this.bentflag = false;
      }else{
         this.bentflag = true;
      }
      /***
       * 平台管理主账号 都可以修改
       * 平台管理子账号 不可以修改 设备生产日期、有效期、供电类型、是否常在线、可监控的字段
       * 经销商子账号正能看不能修改
       * 经销商主账号不可以修改 设备生产日期、有效期、供电类型、是否常在线、可监控的字段
       * 
       */
      // 判断经销商主账号子账号
      if(this.flyNameList == 1 && this.isagree == 0|| this.flyNameList == 2 && this.isagree == 0){//如果是平台子賬號
         this.bentflagJxs = true;
      }else{
         this.bentflagJxs = false;
      }

      this.Camers_Data(); //获取摄像头
      // const res = await gatewayinfo(e.uuid);
      // console.log(res);

      // res.forEach(element => {
      //   let formData = element;
      //   formData.area_uuid = this.area_uuid;

      // });
      this.$nextTick(() => {
        this.$refs.fromData.fileList = [];
        this.$refs.fromData.mapList();
      });
      // 给自组建传值
      // this.apiFly = false; //点击编辑按钮的时候变变成false;
      this.isAdd = true; //判断是否显示按钮 disabled
      this.dialogVisible = true;
      // 如果是客戶或者經銷商不能看通道號
      setTimeout(() => {
        if (this.flyNameList != 0) {
          let boxDnone = document.getElementById("tab-second");
          let boxkongzhi = document.getElementById("tab-kongzhiqi");

          boxDnone.style.display = "none";
          boxkongzhi.style.display = 'none'
        }
      }, 1000);
    },
    //控制板设置
  async KongZhiBna(valueData){
      const {code,data,msg} = await KongZhiList(valueData)
      console.log(data,"--------");
      
    },
    // 关闭弹框
    cancle() {
      this.dialogVisible = false;
    },
    // 给子组件关闭的方法弹框的方法
    closefale() {
      // this.dialogVisible = false;
      this.dataJson = {};
      // this.$refs.fromData.fileList = [];
    },
    // 查看按钮
    lookDlg(e) {
      this.disableDt = false;
      this.title = this.dataobjs.xinzengwanggan;
      this.Camers_Data();
      this.dataJson = {
        gatewayid: "", //网管id
        name: "", //网管名称
        port: "", //端口号
        baudrate: "", //般若氯
        parity: "", //奇偶校验
        area_uuid: this.area_uuid, //所属区域UUID
        type_uuid: "", //所属网关型号UUID
        state: "0", //网关状态0：离线 1：在线
        factorcountint: "", //观察要素个数（通道）
        address: "", //地址
        addressphoto: "", //安装位置照片
        longitude: "", //经度
        latitude: "", //纬度
        altitude: "", //海拔
        productiondate: null, //生产日期
        exprirydate: null, //有效期
        ismonitor: "0", //是否可监控0：否 1：是  1true
        iscontrol: "0", //是否可控制0：否 1：是
        ismove: "0", //是否可移动0：否 1：是
        uploadtime: "", //数据上传频率(分)
        powertype: "0",
        isallonline: "0", //供电类型0：市电供电 1：电池供电
      };

      this.dialogVisible = true;
    },
    // 关闭弹框
    handleClose() {
      // console.log('111');
      //
      this.closefale();

      this.dataJson = {};
      this.gateway_uuid = "";
      this.activeName = "first";
      this.flyUuid = "";
      this.fnet = false;
      this.$refs.tableROM.tableDataOut = [];
      this.$refs.fromData.fileList = [];

      // done();
      this.$nextTick(() => {
        this.$refs.fromData.cloneClick();
        //  this.$refs.fromData.closefale()
      });
      this.dialogVisible = false;
    },
    //删除数据
    deleData(e) {
      this.Delectloading = true;
      this.$confirm(`${this.dataobjs.tishixinxi}`, `${this.dataobjs.tishi}`, {
        confirmButtonText: `${this.dataobjs.queding}`,
        cancelButtonText: `${this.dataobjs.quxiao}`,
        closeOnClickModal: false,
        type: "warning",
      })
        .then(async () => {
          let tablename = "tb_gateway";
          const { code, data, msg } = await dealerDelete(e.uuid, tablename);
          if (code) {
            // this.GatewayinfoTab();
            this.countDateName();
            this.Delectloading = false;
            this.$message({
              type: "success",
              message: `${this.dataobjs.shanchuchenggong}!`,
            });
            this.cunt = false;
          } else {
            this.Delectloading = false;
            this.$message.error(msg);
          }
        })
        .catch(() => {
          this.Delectloading = false;
          this.$message({
            type: "info",
            message: `${this.dataobjs.yiquxiaoshanchu}`,
          });
        });
    },
  },
};
</script>
<style >
/* #tab-second{
  display: none;
} */
.el-dialog__wrapper {
  z-index: 1000 !important;
}
.contHeader {
  display: flex;
}
.fromListNe {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.rightfor {
  width: 257px;
  height: 100%;
  overflow: auto;
}
.leftNNert {
  /* flex: 80%; */
  width: 80%;
  height: 500px;
  /* overflow: auto; */
  padding: 0 10px;
}
.storch {
  display: flex;
  padding-bottom: 15px;
}
.storch button {
  margin: 0 10px;
}
.newimgList_Warp {
  position: absolute;
  left: 0;
  top: 50%;
}
</style>
